import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { message } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { UPDATE_TEAM_MEMBER, GET_TEAM } from 'gql/team';
import ProjectHeader from '../../ProjectHeader';
import TeamForm from './components/TeamForm';

const EditTeam = () => {
  const { projectId, id } = useParams();
  const history = useHistory();
  const [editTeamMember] = useMutation(UPDATE_TEAM_MEMBER, {
    refetchQueries: [
      {
        query: GET_TEAM,
        variables: {
          projectId,
        },
      },
    ],
    onCompleted: () => {
      history.push(`/projects/${projectId}/team`);
    },
  });
  const { data, loading } = useQuery(GET_TEAM, {
    variables: {
      projectId,
      ids: [id],
    },
  });
  const onFinish = async ({ user, teamMemberType }) => {
    const {
      data: {
        updateTeamMember: {
          user: { name },
        },
      },
    } = await editTeamMember({
      variables: {
        input: {
          id,
          user,
          teamMemberType,
          projectId,
        },
      },
    });
    message.success(`${name} is edited successfully`);
    return true;
  };
  const initialValues = data?.team[0]
    ? {
        user: data?.team[0].user.id,
        teamMemberType: data?.team[0].teamMemberType.id,
        faculty: data?.team[0].user.faculty?.id,
        department: data?.team[0].user.department?.id,
      }
    : {};

  return (
    <ProjectHeader>
      <PageContainer title="Edit Team Member" loading={loading}>
        <TeamForm onFinish={onFinish} initialValues={initialValues} />
      </PageContainer>
    </ProjectHeader>
  );
};

export default EditTeam;
